import React, { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import { buildCriteriaKey } from "/src/utils/criteriaKey";

const CONVERSATIONS_LIST_PATH = '/supervision/conversations/list';

const ModalAgentPerformanceArray = ({ enrichedData = [], agent }) => {
    const rowData = useMemo(() => {
        return enrichedData.map((c) => ({
            id: c.id,
            criteria: c.name,
            category: c.category || "Unknown",
            score: c.score ?? 0,
            failed: c.failed ?? 0,
            result: `${c.failed ?? 0}/${c.total ?? 0}`
        }));
    }, [enrichedData]);

    const buildFailuresHref = (row) => {
        const params = new URLSearchParams();
        if (agent) params.append("agent_id", agent);
        params.append("criteria_ids", buildCriteriaKey(row.category, row.id));
        params.append("criteria_categories", row.category);
        params.append("criteria_results", "fail");
        return `${CONVERSATIONS_LIST_PATH}?${params.toString()}`;
    };

    const columnDefs = useMemo(() => [
        {
            headerName: "Criteria",
            field: "criteria",
            flex: 2,
            sortable: true,
            filter: true
        },
        {
            headerName: "Category",
            field: "category",
            flex: 1,
            sortable: true,
            filter: true
        },
        {
            headerName: "Score",
            field: "score",
            width: 120,
            sortable: true,
            cellRenderer: (params) => (
                <span style={{ fontWeight: "bold" }}>
                    {params.value}%
                </span>
            )
        },
        {
            headerName: "Failure rate",
            field: "result",
            width: 120,
            sortable: true,
            cellRenderer: (params) => (
                params.data.failed > 0 ? (
                    <a
                        href={buildFailuresHref(params.data)}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "var(--main)", fontWeight: 600 }}
                    >
                        {params.value}
                    </a>
                ) : (
                    <span style={{ color: "#999" }}>{params.value}</span>
                )
            )
        }
    ], [agent]);

    return (
        <div
            className="ag-theme-alpine"
            style={{ width: "100%", height: "600px" }}
        >
            <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={{
                    resizable: true,
                    sortable: true
                }}
                pagination={true}
                paginationPageSize={20}
            />
        </div>
    );
};

export default ModalAgentPerformanceArray;